<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template><div class="legal-page">
  <div class="legal-page">
    <section class="legal-hero">
      <div class="legal-hero-content">
        <span>Rechtliches</span>
        <h1>Impressum</h1>
        <p>Angaben zur Anbieterkennzeichnung, Verantwortlichkeit und Kontaktaufnahme.</p>
      </div>

      <div class="legal-hero-panel">
        <strong>Aktueller Rechtsbezug</strong>
        <p>Die Anbieterkennzeichnung verweist auf § 5 DDG.</p>
      </div>
    </section>

    <section class="legal-layout">
      <aside class="legal-aside">
        <span>Auf dieser Seite</span>
        <a href="#anbieter">Anbieter</a>
        <a href="#kontakt">Kontakt</a>
        <a href="#inhalt">Inhalte</a>
        <a href="#links">Links</a>
        <a href="#urheberrecht">Urheberrecht</a>
      </aside>

      <div class="legal-card">
        <div class="legal-note">
          <strong>Hinweis</strong>
          <p>Diese Angaben wurden an die aktuelle Bezeichnung nach DDG angepasst. Eine individuelle Rechtsprüfung ersetzt das nicht.</p>
        </div>

        <h2 id="anbieter">Angaben gemäß § 5 DDG</h2>
        <p>
          Butterweck Digital<br/>
          Inhaber: Maximilian Butterweck<br/>
          Kriemhildenstraße 23<br/>
          65205 Wiesbaden<br/>
          Deutschland
        </p>

        <h2 id="kontakt">Kontakt</h2>
        <p>
          Telefon: +49 (0) 15150784965<br/>
          E-Mail: <a href="mailto:info@butterweck-digital.de">info@butterweck-digital.de</a>
        </p>

        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Maximilian Butterweck<br/>
          Kriemhildenstraße 23<br/>
          65205 Wiesbaden
        </p>

        <h2 id="inhalt">Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
          Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
          hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
          Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen entfernen wir diese Inhalte umgehend.
        </p>

        <h2 id="links">Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
          Deshalb übernehmen wir für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets
          der jeweilige Anbieter oder Betreiber verantwortlich.
        </p>

        <h2 id="urheberrecht">Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung
          und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers.
        </p>
      </div>
    </section>
  </div>
</div></template>
